import React from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  
    return (
      <div   >
      <h1><br />
        getCredit  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
        TERMS OF USE<br /></h1>
<h2>
<b>Clarification: Credit card details will be transferred to the referring party (business or website) and will be handled by him and under his responsibility</b><br />
Any use of the website, both by business owners and by customers and / or credit card holders constitutes consent to the terms of use<br /><br />
<b>for business </b><br />
Do not use credit card information except for the purpose for which the details were given and in amounts agreed in advance with the customer<br />
Do not transfer credit card information to any other party<br />
Liability for collection on the business owner and as agreed with the customer<br />
Do not use a business name that is not genuine or a business name that you do not own<br />
Do not use a logo that is not genuine or a logo that you do not own<br />
Every complaint / claim of the customer, is the responsibility of the referring business and he is obligated to bear responsibility for everything caused by the use of the website by the customer<br />
Do not use a business name or logo that is not real or that is not directly attributed to the referrer<br />
GetCredit's right to change the terms of use later and even charge for its services<br />
Any use of the site and / or the services derived from it and / or customer data received from it in any way, not according to these conditions or not in the usual way and / or not according to the degree of justice and fairness, will obligate the user to pay any damage caused to both getCredit and to users, both direct and indirect damages including damages to image or reputation damage<br />
In every claim and / or claim there will be the sole judiciary, the court of the Eretz Hemda Kollel and it is the sole agreed arbitrator<br />
<br /><br />
<b>Customers</b><br />
Do not enter incorrect credit card information<br />
Do not enter credit card details that are not yours and / or that you do not have permission to use<br />
Do not enter credit card information when you do not want to pay the full amount required<br />
Any claim and / or claim will be directed towards the referrer to the service and / or the entity that uses the credit card data<br />
 getCredit will not be responsible in any way or form for the use of credit card and / or customer data<br />
GetCredit's right to change the terms of use later and even charge for its services<br />
Any use of the site and / or the services derived from it, not according to these conditions or not in the usual way and / or not according to the degree of justice and fairness, will require the user to pay any damage caused to both getCredit and users, both direct and indirect damages Includes compensation for damage to image or reputation<br />
In every claim and / or claim there will be the sole judiciary, the court of the Eretz Hemda Kollel and it is the sole agreed arbitrator<br />

</h2>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/terms_of_use.js